import { Avatar, Button, Dropdown, Flex, Layout, Menu, Tag, Typography } from 'antd'
import type { MenuProps } from 'antd'
import { DashboardOutlined, KeyOutlined, LogoutOutlined, MailOutlined, TeamOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'

const { Content, Footer, Sider } = Layout

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout } = useAuthContext()
  const isAdmin = user?.role === 'admin'
  const selectedKey = location.pathname.startsWith('/emails') ? 'emails'
    : location.pathname.startsWith('/accounts') ? 'accounts'
    : location.pathname.startsWith('/api-keys') ? 'api-keys'
      : location.pathname.startsWith('/auth-users') ? 'auth-users' : 'dashboard'
  const items: MenuProps['items'] = [
    { key: 'dashboard', icon: <DashboardOutlined />, label: 'Обзор' },
    { key: 'emails', icon: <MailOutlined />, label: 'Отправки' },
    ...(isAdmin ? [
      { key: 'accounts', icon: <WalletOutlined />, label: 'Счета' },
      { key: 'api-keys', icon: <KeyOutlined />, label: 'Ключи приложений' },
      { key: 'auth-users', icon: <TeamOutlined />, label: 'Сотрудники' },
    ] : []),
  ]
  const displayName = user?.employeeName || user?.name || user?.email || 'Пользователь'
  const role = user?.role === 'admin' ? 'Администратор' : user?.role === 'operator' ? 'Оператор' : 'Наблюдатель'
  const userItems: MenuProps['items'] = [
    {
      key: 'profile', disabled: true, label: (
        <div className="admin-user-menu-profile">
          <Flex align="center" gap="small">
            <Avatar size={40} src={user?.picture} icon={<UserOutlined />} />
            <div className="admin-user-menu-text"><Typography.Text strong>{displayName}</Typography.Text><Typography.Text type="secondary">{user?.email}</Typography.Text></div>
          </Flex>
          <Tag className="admin-user-menu-role" color={isAdmin ? 'success' : 'processing'}>{role}</Tag>
        </div>
      ),
    },
    { type: 'divider' },
    { key: 'logout', danger: true, icon: <LogoutOutlined />, label: 'Выйти' },
  ]

  const go = (key: string) => {
    if (key === 'logout') void logout().then(() => navigate('/login', { replace: true }))
    else navigate(`/${key}`)
  }

  return (
    <Layout className="admin-layout">
      <Sider className="admin-sider" breakpoint="lg" collapsed={collapsed} collapsedWidth={72} onCollapse={setCollapsed} trigger={null} width={260}>
        <div className="admin-sider-inner">
          <div className="admin-logo" onClick={() => navigate('/dashboard')}>
            <div className="admin-logo-mark">S</div>
            {!collapsed && <div><Typography.Text className="admin-logo-title">SIESTA</Typography.Text><Typography.Text className="admin-logo-subtitle">MAILER</Typography.Text></div>}
          </div>
          <Menu className="admin-menu" theme="dark" mode="inline" selectedKeys={[selectedKey]} items={items} onClick={({ key }) => go(key)} />
          <div className="admin-sider-user">
            <Dropdown trigger={['click']} placement="topLeft" menu={{ items: userItems, onClick: ({ key }) => go(key), className: 'admin-user-menu' }}>
              <Button type="text" className="admin-sidebar-user-trigger" aria-label="Меню пользователя">
                <Avatar size={34} src={user?.picture} icon={<UserOutlined />} />
                {!collapsed && <span className="admin-sidebar-user-text"><Typography.Text className="admin-sidebar-user-name">{displayName}</Typography.Text><Typography.Text className="admin-sidebar-user-role">{role}</Typography.Text></span>}
              </Button>
            </Dropdown>
          </div>
        </div>
      </Sider>
      <Layout className="admin-main">
        <Content className="admin-content"><Outlet /></Content>
        <Footer className="admin-footer"><Flex gap="small"><span>SIESTA MAILER</span><span>2012–2026 © RGL Service Ltd.</span></Flex></Footer>
      </Layout>
    </Layout>
  )
}
